import { useAuth } from "../contexts/AuthContext";

type Action = "view" | "create" | "edit" | "delete";

export function usePermission(module: string, action: Action): boolean {
  const { user, permissions } = useAuth();
  if (!user) return false;
  if (user.role === "ADMIN") return true;
  const perm = permissions?.find((p: any) => p.module === module);
  if (!perm) return false;
  const map: Record<Action, string> = {
    view: "canView", create: "canCreate", edit: "canEdit", delete: "canDelete",
  };
  return !!perm[map[action]];
}

export function useOwnOnly(module: string): boolean {
  const { user, permissions } = useAuth();
  if (!user || user.role === "ADMIN") return false;
  const perm = permissions?.find((p: any) => p.module === module);
  return !!perm?.ownOnly;
}
